import { render, staticRenderFns } from "./ResponsibleAreasList.vue?vue&type=template&id=10e2190a&scoped=true&"
import script from "./ResponsibleAreasList.vue?vue&type=script&lang=js&"
export * from "./ResponsibleAreasList.vue?vue&type=script&lang=js&"
import style0 from "./ResponsibleAreasList.vue?vue&type=style&index=0&id=10e2190a&lang=scss&scoped=true&"
import style1 from "./ResponsibleAreasList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2190a",
  null
  
)

export default component.exports